import { cn } from './ui';

export interface ResponseSummary {
  session_id: string;
  match_id: string | null;
  kind: string;
  yes: number;
  maybe: number;
  no: number;
  pending: number;
}

const TEILE: { key: 'yes' | 'maybe' | 'no' | 'pending'; farbe: string; text: (n: number) => string }[] = [
  { key: 'yes', farbe: 'bg-emerald-500', text: (n) => `${n} ${n === 1 ? 'Zusage' : 'Zusagen'}` },
  { key: 'maybe', farbe: 'bg-orange-400', text: (n) => `${n} vielleicht` },
  { key: 'no', farbe: 'bg-rose-500', text: (n) => `${n} ${n === 1 ? 'Absage' : 'Absagen'}` },
  { key: 'pending', farbe: 'bg-slate-300', text: (n) => `${n} offen` },
];

/** Kurzwort hinter der Zahl - eine nackte Zahl verraet nicht, wofuer sie steht. */
const KURZ = { yes: 'zu', maybe: 'vielleicht', no: 'ab', pending: 'offen' } as const;

/**
 * Rueckmeldungen auf einen Blick: gruen zugesagt, orange vielleicht, rot
 * abgesagt, grau offen. Nur Zahlen - wer genau, steht in der Anwesenheit.
 */
export function ResponseTally({ summary, className }: { summary: ResponseSummary | undefined; className?: string }): JSX.Element | null {
  if (!summary) return null;
  const teile = TEILE.filter((teil) => summary[teil.key] > 0);
  if (teile.length === 0) return null;
  const beschreibung = teile.map((teil) => teil.text(summary[teil.key])).join(' · ');
  return (
    <span className={cn('mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-600', className)} title={beschreibung} aria-label={`Rückmeldungen: ${beschreibung}`}>
      {teile.map((teil) => (
        <span key={teil.key} className="inline-flex items-center gap-1" aria-hidden="true">
          <span className={cn('h-2.5 w-2.5 rounded-full', teil.farbe)} />
          <span><span className="tabular-nums font-medium">{summary[teil.key]}</span> {KURZ[teil.key]}</span>
        </span>
      ))}
    </span>
  );
}
